import { combineReducers } from 'redux';
import { userReducer } from './users';
import { loadingReducer } from './loading';
import { uiReducer } from './ui';

export default combineReducers({
    ui: uiReducer,
    loading: loadingReducer,
    user: userReducer,
});